import { callAPi, callAPiMultiPart } from "./api";

const create = (data) => callAPiMultiPart.post("/admin/bylaws", data);
const edit = (data, id) => callAPiMultiPart.patch(`/admin/bylaws/${id}`, data);
const get = () => callAPi.get("/bylaws");
const getByID = (id) => callAPi.get(`/bylaws/${id}`);

const deleteByLaws = (id) => callAPi.delete(`/admin/bylaws/${id}`);

const ByLawsServices = {
  create,
  edit,
  get,
  deleteByLaws,
  getByID,
};

export default ByLawsServices;
